import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import GolfCoursePage from "@/pages/GolfCoursePage";
import HotelResortPage from "@/pages/HotelResortPage";
import ResidentialPage from "@/pages/ResidentialPage";
import CareersPage from "@/pages/CareersPage";
import TreeCareBlogPage from "@/pages/TreeCareBlogPage";

import TreeTrimmingParadiseValley from "@/pages/landing/TreeTrimmingParadiseValley";
import TreeRemovalParadiseValley from "@/pages/landing/TreeRemovalParadiseValley";
import TreeServiceParadiseValley from "@/pages/landing/TreeServiceParadiseValley";
import TreePruningParadiseValley from "@/pages/landing/TreePruningParadiseValley";
import ArboristParadiseValley from "@/pages/landing/ArboristParadiseValley";
import StumpGrindingParadiseValley from "@/pages/landing/StumpGrindingParadiseValley";
import TreeDoctorParadiseValley from "@/pages/landing/TreeDoctorParadiseValley";
import TreeTrimmingScottsdale from "@/pages/landing/TreeTrimmingScottsdale";
import TreeRemovalScottsdale from "@/pages/landing/TreeRemovalScottsdale";
import TreeServiceScottsdale from "@/pages/landing/TreeServiceScottsdale";
import TreePruningScottsdale from "@/pages/landing/TreePruningScottsdale";
import StumpGrindingScottsdale from "@/pages/landing/StumpGrindingScottsdale";
import TreeCareScottsdale from "@/pages/landing/TreeCareScottsdale";
import EmergencyTreeRemovalPhoenix from "@/pages/landing/EmergencyTreeRemovalPhoenix";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/golf-courses" element={<GolfCoursePage />} />
          <Route path="/hotels-resorts" element={<HotelResortPage />} />
          <Route path="/residential" element={<ResidentialPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/tree-care-guide" element={<TreeCareBlogPage />} />

          {/* SEO Landing Pages - Paradise Valley */}
          <Route path="/tree-trimming-paradise-valley" element={<TreeTrimmingParadiseValley />} />
          <Route path="/tree-removal-paradise-valley" element={<TreeRemovalParadiseValley />} />
          <Route path="/tree-service-paradise-valley" element={<TreeServiceParadiseValley />} />
          <Route path="/tree-pruning-paradise-valley" element={<TreePruningParadiseValley />} />
          <Route path="/arborist-paradise-valley" element={<ArboristParadiseValley />} />
          <Route path="/stump-grinding-paradise-valley" element={<StumpGrindingParadiseValley />} />
          <Route path="/tree-doctor-paradise-valley" element={<TreeDoctorParadiseValley />} />

          {/* SEO Landing Pages - Scottsdale */}
          <Route path="/tree-trimming-scottsdale" element={<TreeTrimmingScottsdale />} />
          <Route path="/tree-removal-scottsdale" element={<TreeRemovalScottsdale />} />
          <Route path="/tree-service-scottsdale" element={<TreeServiceScottsdale />} />
          <Route path="/tree-pruning-scottsdale" element={<TreePruningScottsdale />} />
          <Route path="/stump-grinding-scottsdale" element={<StumpGrindingScottsdale />} />
          <Route path="/tree-care-scottsdale" element={<TreeCareScottsdale />} />

          {/* SEO Landing Pages - Phoenix */}
          <Route path="/emergency-tree-removal-phoenix" element={<EmergencyTreeRemovalPhoenix />} />

          {/* 301 Redirects for old WordPress URLs (Google still has these indexed) */}
          <Route path="/get-a-quote" element={<Navigate to="/#contact" replace />} />
          <Route path="/get-a-quote/" element={<Navigate to="/#contact" replace />} />
          <Route path="/tag/*" element={<Navigate to="/tree-care-guide" replace />} />
          <Route path="/author/*" element={<Navigate to="/" replace />} />
          <Route path="/category/phoenix" element={<Navigate to="/emergency-tree-removal-phoenix" replace />} />
          <Route path="/category/phoenix/" element={<Navigate to="/emergency-tree-removal-phoenix" replace />} />
          <Route path="/category/*" element={<Navigate to="/" replace />} />
          <Route path="/elementor-hf/*" element={<Navigate to="/" replace />} />
          <Route path="/2025/*" element={<Navigate to="/tree-care-guide" replace />} />
          <Route path="/wp-admin/*" element={<Navigate to="/" replace />} />
          <Route path="/feed/*" element={<Navigate to="/" replace />} />

          {/* Catch-all: send any unknown URL to homepage */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
    </HelmetProvider>
  );
}

export default App;
